import { ResourcefulReducer } from '../../util';

const WidgetReducer = new ResourcefulReducer('widget');

global.widget_reducer = WidgetReducer;

export default WidgetReducer;



// WEBPACK FOOTER //
// ./src/example_app/reducer/widget_reducer.js